import { AttachmentList } from 'app/src/shared/components/AttachmentList'
import { useWebAppContext } from 'app/src/shared/hooks'
import { useTranslation } from 'react-i18next'

export function TermsSection() {
  const context = useWebAppContext()
  const { t } = useTranslation('landing', { keyPrefix: 'Landing.Terms' })

  return (
    context.userInfo.welfareCampaign.documents &&
    context.userInfo.welfareCampaign.documents.some((el) => el.type === 'terms_and_conditions') && (
      <AttachmentList
        attachments={context.userInfo.welfareCampaign.documents
          .filter((el) => el.type === 'terms_and_conditions')
          .map((d) => ({
            id: d.documentId!,
            name: d.name!,
            resourceLink: d.url,
            type: d.type!,
          }))}
        title={t('Title')}
      />
    )
  )
}
